import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArticleCard from "./ArticleCard";

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    className="absolute top-1/2 -right-8 z-10 hidden xl:flex -translate-y-1/2 items-center justify-center h-12 w-12 rounded-full bg-white text-[#102a72] shadow-lg border border-white/60 hover:bg-[#1746a2] hover:text-white transition-all duration-200"
    onClick={onClick}
    aria-label="Siguiente artículo"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M9.29 6.71a1 1 0 011.42 0L15 11l-4.29 4.29a1 1 0 11-1.42-1.42L12.17 12l-2.88-2.88a1 1 0 010-1.41z" />
    </svg>
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="absolute top-1/2 -left-8 z-10 hidden xl:flex -translate-y-1/2 items-center justify-center h-12 w-12 rounded-full bg-white text-[#102a72] shadow-lg border border-white/60 hover:bg-[#1746a2] hover:text-white transition-all duration-200"
    onClick={onClick}
    aria-label="Artículo anterior"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M14.71 6.71a1 1 0 010 1.41L11.83 12l2.88 2.88a1 1 0 01-1.42 1.42L9 12l4.29-4.29a1 1 0 011.42 0z" />
    </svg>
  </button>
);

const LatestArticlesCarousel = ({ articles, basePath = "/blog", categories }) => {
  if (!articles || articles.length === 0) {
    return null;
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="bg-gradient-to-br from-[#091447] via-[#0f1a49] to-[#1746a2] py-14 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 xl:px-20 relative overflow-hidden">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 mb-10 text-center sm:text-left">
          <div>
            <p className="text-xs sm:text-sm font-semibold text-white/70 uppercase tracking-[0.3em]">
              Lo más reciente
            </p>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mt-2">
              Novedades frescas para ti
            </h2>
          </div>
          <p className="text-white/70 max-w-lg text-sm sm:text-base mx-auto sm:mx-0">
            Revisa las publicaciones más recientes y guarda tus favoritas para consultarlas cuando las necesites.
          </p>
        </div>
        <Slider
          {...settings}
          className="blog-latest-slider [&_.slick-track]:flex [&_.slick-track]:justify-center [&_.slick-slide]:px-3 sm:[&_.slick-slide]:px-6 [&_.slick-slide]:py-8 sm:[&_.slick-slide]:py-10 [&_.slick-slide]:h-auto [&_.slick-list]:overflow-visible sm:[&_.slick-list]:overflow-hidden px-2 sm:px-6"
        >
          {articles.map((article) => (
            <div key={article.slug} className="h-full">
              <ArticleCard
                article={article}
                basePath={basePath}
                categories={categories}
                className="flex-1 min-h-[460px] sm:min-h-[520px] max-w-[360px] w-full mx-auto"
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default LatestArticlesCarousel;
